import styled from 'styled-components'

export const Container = styled.div<{ $renderWithLargeGap?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $renderWithLargeGap }) => ($renderWithLargeGap ? '6px' : '4px')};
`

export const RatingContainer = styled.div<{ $renderWithSpaceBetween?: boolean }>`
  display: flex;
  gap: 8px;
  ${({ $renderWithSpaceBetween }) => $renderWithSpaceBetween && 'justify-content: space-between'};
`

export const BadgesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`
